import React from "react";
import SectionHeading from "../common/SectionHeading";
import { studioServices } from "../../data/site";
import "./Services.css";

/**
 * What the studio does, as a numbered index rather than a row of icon cards.
 *
 * Four services is too few to justify a grid and too many to bury in a
 * paragraph, so each one gets a full-width row: ordinal, name, description.
 * The rows are separated by hairlines and fill with ink on hover, which gives
 * the section a sense of being a table of contents for the practice.
 *
 * @returns {JSX.Element}
 */
function Services() {
  return (
    <section className="services section" id="usluge">
      <div className="shell">
        <SectionHeading
          index="01"
          eyebrow="Usluge"
          headlineLines={["Od ideje do", "gotovog objekta."]}
          aside={`${studioServices.length} oblasti`}
        />
      </div>

      <ol className="services__list" role="list">
        {studioServices.map((service, serviceIndex) => (
          <li
            className="service-row"
            key={service.id}
            data-reveal="rise-sm"
            style={{ "--reveal-delay": `${serviceIndex * 90}ms` }}
          >
            <div className="service-row__wipe" aria-hidden="true" />
            <div className="service-row__inner shell">
              <span className="service-row__index t-numeral">{service.index}</span>
              <h3 className="service-row__title">{service.title}</h3>
              <p className="service-row__description">{service.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Services;
